import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getCookie } from "./httpClient";

import { useSelector } from "react-redux";
import Loader from "../components/Loader";

function MentorProtectedRoute({ children }) {
  const isAuthenticated = getCookie("token");

  const profile = useSelector((store) => store.profile);
  let location = useLocation();
  if (profile?.success == true) {
    if (profile?.data?.mentor == null) {
      return (
        <Navigate
          to="/mentor-create/become-mentor"
          //   state={{ from: location }} replace
        />
      );
    } else if (
      profile?.data?.mentor?.applicationStage == "submitted" ||
      profile?.data?.mentor?.applicationStage == "rejected"
    ) {
      return (
        <Navigate
          to={`/application-status/mentor/${profile?.data?.mentor?._id}`}
          //   state={{ from: location }} replace
        />
      );
    } else {
      return children;
    }
  } else {
    return <Loader message="Please wait!!!" />;
  }
}

export default MentorProtectedRoute;
